import { Capacitor } from '@capacitor/core';

export const initNewRelic = async () => {
    // We are using the default values for the Agent Configuration take a look at
    // https://docs.newrelic.com/docs/mobile-monitoring/new-relic-mobile/mobile-sdk/configure-settings/
    // For the available options.

    // We have to import this dynamically because New Relic throws an infiinte loop of errors on web
    const { NewRelicCapacitorPlugin } = await import('@newrelic/newrelic-capacitor-plugin');

    if (Capacitor.getPlatform() === 'ios') {
        const iOSAppToken = Capacitor.DEBUG
            ? process.env.NEWRELIC_APP_KEY_IOS_DEBUG
            : process.env.NEWRELIC_APP_KEY_IOS_RELEASE;

        NewRelicCapacitorPlugin.start({ appKey: iOSAppToken });
    } else if (Capacitor.getPlatform() === 'android') {
        const androidAppToken = Capacitor.DEBUG
            ? process.env.NEWRELIC_APP_KEY_ANDROID_DEBUG
            : process.env.NEWRELIC_APP_KEY_ANDROID_RELEASE;

        NewRelicCapacitorPlugin.start({ appKey: androidAppToken });
    }

    if ($f.active_user && $f.active_user.is_logged_in()) {
        NewRelicCapacitorPlugin.setUserId({ userId: `${$f.active_user.id}` });
        NewRelicCapacitorPlugin.setAttribute({ name: 'user_email', value: $f.active_user.get('email') });
        NewRelicCapacitorPlugin.setAttribute({ name: 'company_name', value: $f.active_company.get('name') });
        NewRelicCapacitorPlugin.setAttribute({ name: 'company_id', value: `${$f.active_company.id}` });
    }
};
